<template>
</template>

<script>
import {config} from "@/util/config";

export default {
  name: "Redirect",
  components: {
  },
  data() {
    return {
    }
  },
  created() {
      let user_type = this.$store.getters.getUsertype();
      let links = config.children;
      let lastTab = this.$store.getters.getTab();
      //console.log(lastTab);
      //console.log(typeof lastTab);
      if (!lastTab || lastTab === "null") 
        lastTab = null;
      else
        lastTab = lastTab.split(",");

      //console.log("user_type:" + user_type);
      //console.log("lastTab:" + JSON.stringify(lastTab));
      //console.log(JSON.stringify(links));  


      let that = this;
      this.post('https://ipinfo.io', {}).then(function(response) {
          that.$store.commit('setip', response.ip);
      }).catch(function(e){
          console.log(e);
      });

      if (lastTab && lastTab.length > 0) 
      { 
        for (let i = 0; i < lastTab.length; i++) {
          for (let j = 0; j < links.length; j ++){
            let item = links[j];
            if (item.name == lastTab[i] && item.meta.show && item.permission[user_type])
            {
              if (item.children) {
                links = item.children;
              } else {
                this.$router.push(item.path);
                return;
              }
            }
          }
        }
      }

      //otherwise find the first displayable tab and redirect to it
      for (let i = 0; i < links.length; i ++) {
          let item = links[i];
          
          if (item.meta.show && item.permission[user_type]) {
              this.$router.push(item.path);
              return;
          }
      }
   }
 }
</script>

<style>
</style>
